/* ---------------------------------------------------------------------------
   Money figures count from their old value to the new one instead of snapping.
   Every price node carries its own value in data-fl-cents, so the tween always
   knows where it is starting from, whichever code path repoints it.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";
  var FL = (window.FL = window.FL || {});
  var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");

  FL.tweenMoney = function (node, cents) {
    if (!node) return;
    var to = parseInt(cents, 10);
    if (!isFinite(to)) return;
    var fmt = FL.money || function (c) { return String(c); };
    /* One click repoints a price twice: the variant picker aims at the variant's
       own price, then the purchase-options rebuild aims at the selected plan's.
       Reading the origin back out of data-fl-cents would hand the second call
       the first call's target — equal values, so it would snap instead of move,
       and a variant with no plan would never animate at all. __flVal is what the
       digits actually read right now, so the second call retargets a live tween
       instead of cancelling it into a jump. */
    var from = isFinite(node.__flVal) ? node.__flVal : parseInt(node.getAttribute("data-fl-cents"), 10);
    node.setAttribute("data-fl-cents", to);

    if (node.__flRaf) { cancelAnimationFrame(node.__flRaf); node.__flRaf = 0; }
    if (!isFinite(from) || from === to || !window.requestAnimationFrame || (calm && calm.matches)) {
      node.__flVal = to;
      node.textContent = fmt(to);
      return;
    }
    node.__flVal = from;
    var t0 = 0, dur = 420;
    var step = function (now) {
      if (!t0) t0 = now;
      var t = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      node.__flVal = Math.round(from + (to - from) * eased);
      node.textContent = fmt(node.__flVal);
      node.__flRaf = t < 1 ? requestAnimationFrame(step) : 0;
    };
    node.__flRaf = requestAnimationFrame(step);
  };
})();

/* FOLLIVA INSTRUMENT — product: variant picker, price/ATC sync, gallery, qty */
(function () {
  "use strict";
  var FL = window.FL || {};

  /* "Save €30", not "Save €30,00": whole amounts drop their zeros, as Liquid's
     money_without_trailing_zeros does, so a card reads the same before and
     after the first variant change. */
  function moneyShort(c) {
    var s = FL.money ? FL.money(c) : String(c / 100);
    return c % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, "") : s;
  }

  customElements.define("fl-variant-picker", class extends (FL.Element || HTMLElement) {
    init() {
      var script = this.querySelector("[data-fl-variants]");
      try { this.variants = JSON.parse(script.textContent); } catch (e) { this.variants = []; }
      this.section = this.closest("[class*='fl-x-']");
      this.onChange = this.onChange.bind(this);
      this.addEventListener("change", this.onChange);
      if (this.track) this.track(() => this.removeEventListener("change", this.onChange));
      this.syncCards();
    }
    selectedOptions() {
      return FL.$$(".fl-opt", this).map(function (opt) {
        var checked = opt.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }
    onChange() {
      var sel = this.selectedOptions();
      var variant = this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!variant) return;
      var root = this.section || document;
      var idInput = root.querySelector("[data-fl-variant-id]");
      if (idInput) idInput.value = variant.id;
      // price
      // price can render in more than one place (buy panel + standalone price block)
      FL.$$("[data-fl-price-current]", root).forEach(function (cur) { FL.tweenMoney(cur, variant.price); });
      FL.$$("[data-fl-price-compare]", root).forEach(function (cmp) {
        var deal = variant.compare_at_price > variant.price;
        cmp.hidden = !deal;
        if (deal) FL.tweenMoney(cmp, variant.compare_at_price);
      });
      // ATC state
      var atc = root.querySelector("[data-fl-atc]"), txt = root.querySelector("[data-fl-atc-text]");
      if (atc) { atc.disabled = !variant.available; if (txt) txt.textContent = variant.available ? "Add to cart" : "Sold out"; }
      // gallery
      if (variant.featured_media_id) this.switchMedia(variant.featured_media_id);
      // URL
      try { var u = new URL(window.location.href); u.searchParams.set("variant", variant.id); history.replaceState({}, "", u); } catch (e) {}
      this.syncCards(sel);
      FL.emit && FL.emit("fl:variant:changed", { variant: variant });
    }
    syncCards(sel) {
      var self = this;
      if (!sel) sel = this.selectedOptions();
      /* Autoship checkbox ticked: a card prints its size's plan price, struck
         against compare-at or, without one, the one-time price, so "Save" grows
         by the plan discount; unticked, the one-time prices come back. The tick
         is read as the customer's choice, not as the box's visibility, so it does
         not matter whether the picker or the purchase options react first, and a
         size without a plan simply keeps its one-time price. */
      var tick = (this.section || document).querySelector("[data-fl-subs-toggle]");
      var subOn = !!(tick && tick.checked);
      FL.$$(".fl-opt--cards", this).forEach(function (grp) {
        var oi = parseInt(grp.getAttribute("data-option-index"), 10);
        var deck = grp.querySelector("[data-fl-cards]");
        var chipMode = (deck && deck.getAttribute("data-fl-chip")) || "percent";
        var saveWord = (deck && deck.getAttribute("data-fl-save")) || "Save";
        FL.$$("[data-fl-card]", grp).forEach(function (card) {
          var want = sel.slice();
          want[oi] = card.getAttribute("data-value");
          /* the variant this card buys: its own value, plus whatever the other
             options are set to right now. Falls back to any variant carrying the
             value, so a card never renders an empty price. */
          var v = self.variants.filter(function (x) {
            return x.options.every(function (o, i) { return o === want[i]; });
          })[0] || self.variants.filter(function (x) { return x.options[oi] === want[oi]; })[0];
          if (!v) return;
          var useSub = subOn && v.sp > 0;
          var charge = useSub ? v.sp : v.price;
          var ref = useSub && !(v.compare_at_price > v.price) ? v.price : v.compare_at_price;
          var deal = ref > charge;
          var price = card.querySelector("[data-fl-card-price]"),
              was = card.querySelector("[data-fl-card-was]"),
              chip = card.querySelector("[data-fl-card-chip]"),
              out = card.querySelector("[data-fl-card-out]");
          if (price) FL.tweenMoney(price, charge);
          if (was) {
            was.hidden = !deal;
            if (deal) FL.tweenMoney(was, ref);
          }
          if (chip) {
            chip.hidden = !deal || chipMode === "none";
            if (deal) chip.textContent = chipMode === "amount"
              ? saveWord + " " + moneyShort(ref - charge)
              : "−" + Math.round((ref - charge) * 100 / ref) + "%";
          }
          /* price per month: what this size charges over the months it lasts */
          var permo = card.querySelector("[data-fl-card-permo-amt]"),
              months = parseInt(card.getAttribute("data-fl-months"), 10);
          if (permo && months > 0) FL.tweenMoney(permo, Math.floor(charge / months));
          if (out) out.hidden = !!v.available;
          card.classList.toggle("is-out", !v.available);
        });
      });
    }

    switchMedia(id) {
      var root = this.section || document;
      FL.$$("[data-fl-gallery-main] .fl-pdp__slide", root).forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-media-id") == id); });
      FL.$$("[data-fl-gallery-thumbs] .fl-pdp__thumb", root).forEach(function (t) { t.classList.toggle("is-active", t.getAttribute("data-media-id") == id); });
    }
  });

  /* Gallery thumbs + static qty (delegated) */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".fl-pdp__thumb");
    if (thumb) {
      var root = thumb.closest("[class*='fl-x-']"), id = thumb.getAttribute("data-media-id");
      FL.$$(".fl-pdp__slide", root).forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-media-id") === id); });
      FL.$$(".fl-pdp__thumb", root).forEach(function (t) { t.classList.toggle("is-active", t === thumb); });
      return;
    }
    var up = e.target.closest("[data-fl-qty-static-up]"), down = e.target.closest("[data-fl-qty-static-down]");
    if (up || down) {
      var wrap = (up || down).closest("[data-fl-qty-static]"), inp = wrap && wrap.querySelector("input");
      if (inp) inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (up ? 1 : -1));
    }
  });
})();

/* ---- Quantity breaks + Sticky ATC ---- */
(function () {
  "use strict";
  var FL = window.FL || {};
  document.addEventListener("change", function (e) {
    var r = e.target.closest("[data-fl-qty-breaks] input[type=radio]");
    if (!r) return;
    var tier = r.closest(".fl-tier");
    var qty = tier ? (parseInt(tier.getAttribute("data-qty"), 10) || 1) : 1;
    var form = r.closest("form") || document.querySelector("[data-fl-product-form]");
    var qi = form && form.querySelector("input[name=quantity]");
    if (qi) qi.value = qty;
  });
  function ready(f){ document.readyState!=="loading"?f():document.addEventListener("DOMContentLoaded",f); }
  ready(function () {
    var bar = document.querySelector("[data-fl-sticky-atc]");
    if (!bar) return;
    var mainBtn = document.querySelector("[data-fl-atc]");
    var form = document.querySelector("[data-fl-product-form]");
    if (!mainBtn || !form) return;
    bar.hidden = false;
    /* Bar visibility = scrolled past the main ATC, and no drawer covering it.
       Both inputs are kept as state so closing the drawer can restore the bar:
       the observer only fires on intersection changes, and opening the drawer
       does not scroll the page, so it never fires again on its own. */
    var pastAnchor = false, drawerOpen = false;
    function syncBar() { bar.classList.toggle("is-active", pastAnchor && !drawerOpen); }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var above = en.boundingClientRect.top < 0;
          pastAnchor = !en.isIntersecting && above;
        });
        syncBar();
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
    var addBtn = bar.querySelector("[data-fl-satc-add]");
    if (addBtn) addBtn.addEventListener("click", function () {
      if (window.FL && FL.addFromForm) FL.addFromForm(form);
      else if (typeof form.requestSubmit === "function") form.requestSubmit();
      else { var s = form.querySelector("[type=submit]"); if (s) s.click(); }
    });
    document.addEventListener("fl:drawer:open", function(){ drawerOpen = true; syncBar(); });
    document.addEventListener("fl:drawer:close", function(){ drawerOpen = false; syncBar(); });
  });
})();

/* ---- Purchase options (one-time / subscribe / prepay) --------------------
   Markup is server-rendered; this only keeps it in sync with the variant
   picker and mirrors the selected row's price into the buy panel.
   Delegated listeners + init guard: safe to load twice, safe across
   shopify:section:load. */
(function () {
  "use strict";
  if (window.__flSubsInit) return;
  window.__flSubsInit = true;

  var FL = window.FL || {};
  var $$ = FL.$$ || function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function L(box, key, fallback) { return box.getAttribute("data-l-" + key) || fallback; }

  function discountBadge(box, plan) {
    /* theme editor: the badge can be hidden, or replaced by any text; {percent} = the real plan discount */
    if (box.getAttribute("data-fl-subs-badge-hide") === "1") return "";
    var custom = (box.getAttribute("data-fl-subs-badge") || "").trim();
    /* {percent_cmp} = discount against the struck (compare-at) price, the same figure the cards show (2026-10-10) */
    if (custom) return custom.replace(/\{percent_cmp\}/g, plan.offc > 0 ? String(plan.offc) : (plan.off > 0 ? String(plan.off) : "")).replace(/\{percent\}/g, plan.off > 0 ? String(plan.off) : "");
    return plan.off > 0 ? "−" + plan.off + "%" : "";
  }

  function data(box) {
    if (box.__d) return box.__d;
    var s = box.querySelector("[data-fl-subs-data]");
    try { box.__d = JSON.parse(s.textContent); } catch (e) { box.__d = []; }
    return box.__d;
  }

  /* ---- Autoship checkbox (Purchase options style = check) -----------------
     One row, one checkbox for the size's first plan. Ticked and enabled = the
     plan goes into the form; unticked, or disabled because this size has no
     plan, = one-time. Code never touches "checked": it is the customer's choice
     and it survives a detour through a size without a plan. Every price in the
     section follows the tick: the charge, the strike (compare-at, or the
     one-time price under a plan) and the size cards. */
  function isCheck(box) { return box.getAttribute("data-fl-subs-mode") === "check"; }

  function setMoney(n, cents) {
    if (FL.tweenMoney) FL.tweenMoney(n, cents);
    else if (FL.money) { n.textContent = FL.money(cents); n.setAttribute("data-fl-cents", cents); }
  }

  function syncCheck(box) {
    var tick = box.querySelector("[data-fl-subs-toggle]");
    var row = box.querySelector("[data-fl-subs-row]");
    var rp = row && row.querySelector("[data-fl-subs-rowprice]");
    if (!tick || !rp) return;
    var on = tick.checked && !tick.disabled;
    row.classList.toggle("is-on", on);
    var plan = parseInt(rp.getAttribute("data-cents"), 10) || 0;
    var once = parseInt(rp.getAttribute("data-once"), 10) || 0;
    var cmp = parseInt(rp.getAttribute("data-cmp"), 10) || 0;
    var cents = on && plan > 0 ? plan : once;
    var ref = cmp > once ? cmp : (on ? once : 0);
    var root = box.closest("[class*='fl-x-']") || document;
    $$("[data-fl-price-current]", root).forEach(function (n) { setMoney(n, cents); });
    $$("[data-fl-price-compare]", root).forEach(function (n) {
      n.hidden = !(ref > cents);
      if (ref > cents) setMoney(n, ref);
    });
    var picker = root.querySelector("fl-variant-picker");
    if (picker && picker.variants && typeof picker.syncCards === "function") picker.syncCards();
  }

  /* another size: the row takes that size's first plan; a size without a plan
     hides the box and disables the checkbox, which leaves it out of the form */
  function rebuildCheck(box, entry) {
    var tick = box.querySelector("[data-fl-subs-toggle]");
    var row = box.querySelector("[data-fl-subs-row]");
    var rp = row && row.querySelector("[data-fl-subs-rowprice]");
    if (!tick || !rp) return;
    var p = (entry.plans || [])[0] || null;
    box.hidden = !p;
    tick.disabled = !p;
    tick.value = p ? String(p.id) : "";
    row.setAttribute("data-plan", p ? String(p.id) : "");
    rp.setAttribute("data-once", entry.pc);
    rp.setAttribute("data-cmp", entry.cmp || 0);
    if (p) {
      var chip = row.querySelector("[data-fl-subs-chip]");
      if (chip) { var badge = discountBadge(box, p); chip.hidden = !badge; chip.textContent = badge; }
      var meta = row.querySelector("[data-fl-subs-meta]");
      if (meta) meta.textContent = p.n > 1
        ? p.n + " " + L(box, "deliveries", "deliveries") + " · " + p.pdp + " " + L(box, "each", "each")
        : (p.cadS || p.cadence);
      var save = row.querySelector("[data-fl-subs-save]");
      if (save) { save.hidden = !(p.saveRaw > 0); save.textContent = L(box, "save", "Save") + " " + p.save; }
      rp.textContent = p.pf;
      rp.setAttribute("data-cents", p.pc);
      var permo = row.querySelector("[data-fl-subs-permo]");
      if (permo) {
        var show = p.months > 1 && p.pm;
        permo.hidden = !show;
        permo.textContent = "";
        if (show) {
          permo.appendChild(el("span", "fl-subs__permo-amt", p.pm));
          permo.appendChild(document.createTextNode(L(box, "permo", "/mo")));
        }
      }
    }
    syncCheck(box);
  }

  function syncPrice(box) {
    if (isCheck(box)) { syncCheck(box); return; }
    var row = box.querySelector("[data-fl-subs-row].is-on");
    var p = row && row.querySelector("[data-fl-subs-rowprice]");
    if (!p) return;
    var root = box.closest("[class*='fl-x-']") || document;
    var cents = p.getAttribute("data-cents");
    $$("[data-fl-price-current]", root).forEach(function (n) {
      if (cents != null && FL.tweenMoney) FL.tweenMoney(n, cents);
      else n.textContent = p.textContent.trim();
    });
  }

  function selectRow(box, row) {
    $$("[data-fl-subs-row]", box).forEach(function (r) {
      var on = r === row;
      r.classList.toggle("is-on", on);
      var i = r.querySelector('input[type="radio"]');
      if (i) i.checked = on;
    });
    syncPrice(box);
  }

  function buildRow(box, tpl, p) {
    var row = tpl.cloneNode(true);
    row.setAttribute("data-plan", String(p.id));
    row.classList.remove("is-on");
    var input = row.querySelector('input[type="radio"]');
    input.value = String(p.id);
    input.checked = false;

    var body = row.querySelector(".fl-subs__body");
    body.innerHTML = "";
    var prepaid = p.n > 1;

    var name = el("span", "fl-subs__name");
    name.appendChild(document.createTextNode(
      prepaid ? L(box, "prepay", "Prepay") + " " + p.n + " × " + p.unit
              : L(box, "sub", "Subscribe & save")));
    var badge = discountBadge(box, p);
    if (badge) name.appendChild(el("span", "fl-subs__chip", badge));
    body.appendChild(name);

    body.appendChild(el("span", "fl-subs__meta fl-mono",
      prepaid ? p.n + " " + L(box, "deliveries", "deliveries") + " · " + p.pdp + " " + L(box, "each", "each")
              : p.cadence));

    if (p.saveRaw > 0) {
      body.appendChild(el("span", "fl-subs__save fl-mono", L(box, "save", "Save") + " " + p.save));
    }
    var rp = row.querySelector("[data-fl-subs-rowprice]");
    rp.textContent = p.pf;
    if (p.pc != null) rp.setAttribute("data-cents", p.pc);

    /* the per-month figure only earns its place when a cycle spans more than
       one month; a monthly plan already prints it as the charge. */
    var permo = row.querySelector("[data-fl-subs-permo]");
    if (permo) {
      var show = p.months > 1 && p.pm;
      permo.hidden = !show;
      permo.textContent = "";
      /* same split as the Liquid row: dark amount, muted suffix */
      if (show) {
        permo.appendChild(el("span", "fl-subs__permo-amt", p.pm));
        permo.appendChild(document.createTextNode(L(box, "permo", "/mo")));
      }
    }
    return row;
  }

  function rebuild(box) {
    var form = box.closest("form");
    var idInput = form && form.querySelector("[data-fl-variant-id]");
    if (!idInput) return;
    var vid = String(idInput.value);
    var entry = data(box).filter(function (v) { return String(v.id) === vid; })[0];
    if (!entry) return;
    if (isCheck(box)) { rebuildCheck(box, entry); return; }

    var wrap = box.querySelector("[data-fl-subs-rows]");
    var once = wrap.querySelector('[data-fl-subs-row][data-plan=""]');
    if (!once) return;

    /* Remember WHICH subscription row was chosen by its position, not by its
       text: the next variant offers the same tiers at the same positions but
       with a different cadence, so matching on text would silently drop the
       customer back to one-time. The plan id always comes from the new
       variant's own data, so this can never post a foreign plan. */
    /* Remembering the position off the live DOM alone loses the choice the
       moment a variant offers no plan at all: the picker is forced to one-time,
       and coming back the customer silently pays the one-time price. __pick is
       only ever written by a real click, so it survives that detour. */
    if (box.__pick === undefined) {
      var was = box.querySelector("[data-fl-subs-row].is-on");
      box.__pick = was && was.getAttribute("data-plan")
        ? $$('[data-fl-subs-row]:not([data-plan=""])', box).indexOf(was)
        : -1;
    }
    var keepIdx = box.__pick;

    var op = once.querySelector("[data-fl-subs-rowprice]");
    if (op) { op.textContent = entry.pf; if (entry.pc != null) op.setAttribute("data-cents", entry.pc); }

    $$('[data-fl-subs-row]:not([data-plan=""])', wrap).forEach(function (r) { r.remove(); });

    var restored = null;
    (entry.plans || []).forEach(function (p, i) {
      var row = buildRow(box, once, p);
      wrap.insertBefore(row, once);   /* subscription rows sit above one-time */
      if (i === keepIdx) restored = row;
    });

    box.hidden = !(entry.plans && entry.plans.length);
    selectRow(box, restored || once);
  }


  /* --- keep exactly one selling_plan field in the form -------------------
     The app still injects its own widget (its auto-detect path ignores our
     inputs because they carry data-sls-selling_plan). Its hidden field lands
     BEFORE our radios, and FormData.get() returns the FIRST match — which
     would silently drop the customer's subscription choice.
     We do not remove its container: that would make the app re-inject on the
     next refresh. We only strip the name off its field, so it leaves FormData
     while the app still recognises its own widget as present. */
  function neutraliseAppField(root) {
    $$('.sealsubs-container input[name="selling_plan"], .sealsubs-target-element input[name="selling_plan"]', root || document)
      .forEach(function (i) { i.removeAttribute("name"); });
  }
  neutraliseAppField();
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        if (muts[m].addedNodes && muts[m].addedNodes.length) { neutraliseAppField(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("change", function (e) {
    var i = e.target && e.target.closest && e.target.closest('[data-fl-subs] input[name="selling_plan"]');
    if (!i) return;
    var box = i.closest("[data-fl-subs]"), row = i.closest("[data-fl-subs-row]");
    if (isCheck(box)) { syncCheck(box); return; }
    box.__pick = row.getAttribute("data-plan")
      ? $$('[data-fl-subs-row]:not([data-plan=""])', box).indexOf(row)
      : -1;
    selectRow(box, row);
  });

  document.addEventListener("fl:variant:changed", function () { $$("[data-fl-subs]").forEach(rebuild); });

  document.addEventListener("shopify:section:load", function () {
    $$("[data-fl-subs]").forEach(function (b) { b.__d = null; syncPrice(b); });
  });

  /* A page brought back from history can restore the checkbox the way the
     customer left it while the prices are still the server's. Re-read it. */
  window.addEventListener("pageshow", function () {
    $$('[data-fl-subs-mode="check"]').forEach(function (b) {
      var t = b.querySelector("[data-fl-subs-toggle]");
      if (t && t.checked !== t.defaultChecked) syncCheck(b);
    });
  });
})();

/* ---- Saving on the add-to-cart button ("Save €43 →") ----------------------
   Only where the buy block's show_atc_save is on. Measured against the
   compare-at price when the variant has one, else against the one-time price
   (a plan discount on a size without compare-at), minus what will be charged,
   times the quantity. A prepaid plan charges several deliveries at once, so
   its reference is multiplied by the same count.
   Liquid prints the first number; this keeps it right after a size, plan or
   quantity change. These listeners are added after the picker's, the plan
   rows' and the stepper's, so they read the finished state. */
(function () {
  "use strict";
  if (window.__flAtcSaveInit) return;
  window.__flAtcSaveInit = true;
  var FL = window.FL || {};

  /* "€43", not "€43,00": Liquid prints money_without_trailing_zeros */
  function moneyShort(c) {
    var s = FL.money ? FL.money(c) : String(c / 100);
    return c % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, "") : s;
  }
  function json(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }
  function byId(list, id) {
    return (list || []).filter(function (x) { return String(x.id) === String(id); })[0] || null;
  }

  function sync(form) {
    var box = form.querySelector("[data-fl-atc-save]");
    var amt = box && box.querySelector("[data-fl-atc-save-amt]");
    if (!amt) return;
    var root = form.closest("[class*='fl-x-']") || document;
    var id = (form.querySelector("[data-fl-variant-id]") || {}).value;

    /* the variant's own prices; the attributes cover a product without a picker */
    var price = parseInt(box.getAttribute("data-price"), 10) || 0;
    var ref = parseInt(box.getAttribute("data-ref"), 10) || price;
    var v = byId(json(root.querySelector("[data-fl-variants]")), id);
    if (v) {
      price = v.price;
      ref = v.compare_at_price > v.price ? v.compare_at_price : v.price;
    }

    /* what will be charged: the picked plan row, when a plan is picked */
    var charged = price, n = 1;
    var subs = form.querySelector("[data-fl-subs]");
    var row = subs && !subs.hidden && subs.querySelector("[data-fl-subs-row].is-on");
    var plan = row && row.getAttribute("data-plan");
    if (plan) {
      var cell = row.querySelector("[data-fl-subs-rowprice]");
      var c = cell ? parseInt(cell.getAttribute("data-cents"), 10) : NaN;
      if (c > 0) charged = c;
      var entry = byId(json(subs.querySelector("[data-fl-subs-data]")), id);
      var p = entry && byId(entry.plans, plan);
      if (p && p.n > 1) n = p.n;
    }

    var qi = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    var atc = form.querySelector("[data-fl-atc]");
    var save = (ref * n - charged) * qty;

    box.hidden = !(save > 0) || !!(atc && atc.disabled);
    if (save > 0) amt.textContent = moneyShort(save);
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-fl-product-form]"), sync);
  }

  document.addEventListener("fl:variant:changed", syncAll);
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-fl-subs], [data-fl-qty-breaks], [data-fl-product-form] input[name="quantity"]')) syncAll();
  });
  document.addEventListener("input", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-fl-product-form] input[name="quantity"]')) syncAll();
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-fl-qty-static-up], [data-fl-qty-static-down]")) syncAll();
  });
  document.addEventListener("shopify:section:load", syncAll);
})();

/* ---------------------------------------------------------------------------
   fl-guar — the guarantee panel opens its detail as an overlay, never as an
   accordion: the buy column must not move under the customer's cursor.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var OUT_MS = 140; /* matches the fade-out in fl-product.css */
  function still() { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); }

  /* "Over the panel, under its title": the sheet starts just below the title */
  function place(box, pop) {
    if (!box.classList.contains("fl-guar--over")) return;
    var title = box.querySelector(".fl-guar__title"), top = 0;
    if (title) top = Math.max(0, Math.round(title.getBoundingClientRect().bottom - box.getBoundingClientRect().top + 8));
    pop.style.setProperty("--fl-guar-pop-top", top + "px");
  }

  function shut(box) {
    var pop = box.querySelector("[data-fl-guar-pop]"),
        scrim = box.querySelector("[data-fl-guar-scrim]"),
        btn = box.querySelector("[data-fl-guar-open]");
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (!pop || pop.hidden) { if (scrim) scrim.hidden = true; return; }
    pop.classList.remove("is-open");
    clearTimeout(pop.__flT);
    pop.__flT = setTimeout(function () {
      pop.hidden = true;
      if (scrim) scrim.hidden = true;
    }, still() ? 0 : OUT_MS);
  }

  function openPop(box, pop, scrim, btn) {
    clearTimeout(pop.__flT);
    place(box, pop);
    var fresh = pop.hidden;
    pop.hidden = false;
    if (scrim) scrim.hidden = false;
    btn.setAttribute("aria-expanded", "true");
    if (fresh) { pop.scrollTop = 0; void pop.offsetWidth; } /* commit the start state so it animates */
    pop.classList.add("is-open");
    /* The whole text shows at once, so on a phone the sheet can run past the
       fold. Bring its bottom into view — or, when it is taller than the
       screen, its top, so reading starts at the first line. */
    /* layout box, not getBoundingClientRect: the open animation is still at
       scale(.985) translateY(-6px) here, which would under-measure by ~13px */
    var top = box.getBoundingClientRect().top + pop.offsetTop, h = pop.offsetHeight, vh = window.innerHeight;
    var headH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--fl-header-h")) || 0;
    var dy = h > vh - headH - 24 ? top - headH - 12 : top + h - (vh - 12);
    if (dy > 0) window.scrollBy({ top: dy, behavior: "smooth" });
  }
  function shutAll(except) {
    all("[data-fl-guar]").forEach(function (b) { if (b !== except) shut(b); });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest("[data-fl-guar-close]") || t.closest("[data-fl-guar-scrim]")) {
      var owner = t.closest("[data-fl-guar]");
      if (owner) { e.preventDefault(); shut(owner); }
      return;
    }

    var trigger = t.closest("[data-fl-guar-open]");
    if (trigger) {
      e.preventDefault();
      var box = trigger.closest("[data-fl-guar]");
      if (!box) return;
      var pop = box.querySelector("[data-fl-guar-pop]"),
          scrim = box.querySelector("[data-fl-guar-scrim]");
      if (!pop) return;
      var opening = !pop.classList.contains("is-open");
      shutAll(box);
      if (opening) openPop(box, pop, scrim, trigger); else shut(box);
      return;
    }

    /* a click anywhere on the open panel closes it, inside included — only a
       real link inside keeps its own job. */
    var inside = t.closest("[data-fl-guar-pop]");
    if (!inside || !t.closest("a[href]")) shutAll();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.key === "Esc") shutAll();
  });

  /* the title can rewrap on resize/rotate — keep an open sheet under it */
  var raf = 0;
  window.addEventListener("resize", function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      all("[data-fl-guar]").forEach(function (b) {
        var p = b.querySelector("[data-fl-guar-pop]");
        if (p && p.classList.contains("is-open")) place(b, p);
      });
    });
  });
})();

/* ---------------------------------------------------------------------------
   Collapsible rows — one open at a time. The `name` attribute on <details>
   already does this in current browsers; this covers older Safari, and keeps
   the row you tapped where it was instead of letting it jump up by the height
   of the row that just closed above it.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var sum = e.target && e.target.closest ? e.target.closest("details[data-fl-acc] > summary") : null;
    if (!sum) return;
    var det = sum.parentNode;
    if (det.open) return; /* closing it moves nothing above */
    var group = det.getAttribute("data-fl-acc");
    var before = sum.getBoundingClientRect().top;
    var shut = false;
    Array.prototype.forEach.call(document.querySelectorAll('details[data-fl-acc="' + group + '"][open]'), function (d) {
      if (d !== det) { d.open = false; shut = true; }
    });
    if (!shut) return;
    var delta = sum.getBoundingClientRect().top - before;
    if (Math.abs(delta) < 1) return;
    /* html has scroll-behavior:smooth — this correction has to land at once */
    var html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollBy(0, delta);
    html.style.scrollBehavior = prev;
  });
})();
